const home = {
  welcome: 'Welcome back',
  glad: 'Glad to see you again !',
};

export default home;
